import React from "react";
import { Link } from "react-router-dom";
import { Check, Flame, Mic, Clapperboard, Crown, Gem } from "lucide-react";

const FREE = ["Unlimited texting with every standard character", "Group scenes & in-story character chats", "Full library, Human Hearts & reels", "Write and submit your own stories"];
const EXTRAS = [
  { Icon: Flame, label: "Steamy Mode", price: "10 gems / 24h" },
  { Icon: Mic, label: "Voice replies & calls", price: "2 gems / reply" },
  { Icon: Clapperboard, label: "Video & share clips", price: "10 gems / clip" },
  { Icon: Crown, label: "Rare & legendary characters", price: "30–120 gems" },
];

export const FreeVsExtras = () => (
  <section data-testid="free-vs-extras" className="max-w-7xl mx-auto px-4 sm:px-6 py-16 md:py-20">
    <div className="grid md:grid-cols-2 gap-4 md:gap-6">
      <div className="rounded-3xl border border-sky-400/30 bg-sky-400/5 p-6 md:p-10">
        <div className="font-mono text-[11px] uppercase tracking-[0.24em] text-sky-300 mb-2">Always free</div>
        <h2 className="font-serif text-3xl md:text-4xl font-bold mb-6">No meter. No per-message fees.</h2>
        <ul className="space-y-3">
          {FREE.map((f) => (
            <li key={f} className="flex items-start gap-3 text-slate-200"><Check className="h-5 w-5 text-sky-300 mt-0.5 shrink-0" /> {f}</li>
          ))}
        </ul>
      </div>
      <div className="rounded-3xl neon-ring bg-amber-500/5 p-6 md:p-10">
        <div className="font-mono text-[11px] uppercase tracking-[0.24em] text-amber-300 mb-2">Pay only when you want more</div>
        <h2 className="font-serif text-3xl md:text-4xl font-bold mb-6">Turn up the experience.</h2>
        <ul className="space-y-3">
          {EXTRAS.map(({ Icon, label, price }) => (
            <li key={label} className="flex items-center justify-between gap-3 border-b border-white/5 pb-3">
              <span className="flex items-center gap-3 text-slate-200"><Icon className="h-5 w-5 text-amber-400" /> {label}</span>
              <span className="text-xs font-mono text-amber-200 flex items-center gap-1"><Gem className="h-3 w-3" /> {price}</span>
            </li>
          ))}
        </ul>
        <Link to="/pricing" data-testid="extras-subscribe" className="mt-6 inline-flex h-11 items-center rounded-full bg-amber-500 hover:bg-amber-400 text-black font-bold px-6 transition-colors">Or subscribe — every extra included</Link>
      </div>
    </div>
  </section>
);
